import {
  titleUI,
  bankAccountSchema,
  bankAccountUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const updatedBankAccountSchema = bankAccountSchema();
updatedBankAccountSchema.required = [
  'bankName',
  'accountType',
  'accountNumber',
  'routingNumber',
];
updatedBankAccountSchema.properties.bankName.maxLength = 34;

function dependsIfHasBankAccount(formData) {
  return (
    formData?.hasBankAccount === true ||
    formData?.hasBankAccount === 'Y' ||
    formData?.hasBankAccount === 'yes'
  );
}

/** @type {PageSchema} */
export default {
  depends: dependsIfHasBankAccount,
  uiSchema: {
    ...titleUI(content['additional-info-account-title']),
    bankAccount: (() => {
      const bankAccount = bankAccountUI({
        labels: {
          routingNumberLabel: content['additional-info-account-routing-number'],
        },
      });
      bankAccount.bankName = {
        ...bankAccount.bankName,
        'ui:errorMessages': {
          required: content['additional-info-account-bank-name-error'],
        },
      };
      bankAccount.accountNumber = {
        ...bankAccount.accountNumber,
        'ui:errorMessages': {
          ...bankAccount.accountNumber['ui:errorMessages'],
          required: content['additional-info-account-bank-account-error'],
        },
      };
      bankAccount.routingNumber = {
        ...bankAccount.routingNumber,
        'ui:errorMessages': {
          ...bankAccount.routingNumber['ui:errorMessages'],
          required: content['additional-info-account-bank-routing-error'],
        },
      };
      return bankAccount;
    })(),
  },
  schema: {
    type: 'object',
    required: ['bankAccount'],
    properties: {
      bankAccount: updatedBankAccountSchema,
    },
  },
};
